export default "__VITE_ASSET__iUjQ828L__"